import { TTranslateFunction } from '@modules/localization/types/TranslateFunction';
import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';
import { walkSchemaChildren } from './walkSchemaChildren';
import resolveReference from './resolveReference';

export default function getImmutableMarkdown(
  translate: TTranslateFunction,
  operation: OpenAPI.OperationObject,
  document: OpenAPI.Document,
): string {
  const immutableFields: Set<string> = new Set();

  if (operation.requestBody === undefined) {
    return '';
  }

  let requestBody: OpenAPI.RequestBodyObject | undefined;
  if ('$ref' in operation.requestBody) {
    requestBody = resolveReference(document, operation.requestBody, 'requestBodies');
    if (requestBody === undefined) {
      return '';
    }
  } else {
    requestBody = operation.requestBody;
  }

  if (Object.keys(requestBody.content).length === 0) {
    return '';
  }

  // Assume first content type is sufficient for the check
  const firstContent = Object.values(requestBody.content)[0];

  if (firstContent.schema === undefined) {
    return '';
  }

  walkSchemaChildren(firstContent.schema, document, (fieldName, schema) => {
    if (schema['x-immutable'] === true) {
      immutableFields.add(fieldName);
    }
  });

  if (immutableFields.size === 0) {
    return '';
  }

  return `${translate('Description.ImmutablePlural')}\n\n${immutableFields
    .values()
    .map((field) => `- \`${field}\``)
    .toArray()
    .join('\n')}`;
}
